import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  contractSelect,
  getContractDepthRequested,
  getCurrentSessionsRequested,
} from "../../../redux/actions/sessions";
import moment from "moment";
import { API_DELETE, API_GET, API_POST } from "../../../helpers/api";
import Modal from "../../../components/Modal";
import TitleValue from "../../../components/TitleValue";
import Pill from "../../../components/Pill";
import Button from "../../../components/Button";
import DataTable from "../../../components/DataTable";
import DataTableBasic from "../../../components/DataTable/DataTableBasic";
import DataTableDraggable from "../../../components/DataTable/DataTableDraggable";
import OfferTab from "../../../components/OfferTab";
import { setNotification } from "../../../helpers/notification";
import { Input, Select, Textarea } from "../../../components/Inputs";
import EmptyState from "../../../components/EmptyState/EmptyState";
import {
  getActiveOffersRequested,
  getSystemParticipantMatchesRequested,
} from "../../../redux/actions/offers";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../../helpers/convert";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import Icon from "../../../components/Icon";
import ModalEditSellOffer from "../../../components/Modal/ModalEditSellOffer";
import LabelValue from "../../../components/LabelValue";
import PriceInput from "../../../components/Inputs/PriceInput";
import ToggleSwitch from "../../../components/ToggleSwitch";
import OfferHandler from "../../../components/OfferHandler";
import Loading from "../../../components/Loading";

export default function OfferOperations({ t, history }) {
  const dispatch = useDispatch();
  const serverTime = useSelector((state) => state.utilities.serverTime);
  let timer1 = null;
  const [intervalState, setIntervalState] = useState(null);
  const selectedOrganization = useSelector(
    (state) => state.authorization.user.organization
  );
  const user = useSelector((state) => state.authorization.user);

  const { currentContracts, loading } = useSelector((state) => state.sessions);

  const selectedContract = useSelector(
    (state) => state.sessions.selectedContract
  );
  const contractDepthBuyList = useSelector(
    (state) => state.sessions.contractDepthBUYList
  );
  const contractDepthSellList = useSelector(
    (state) => state.sessions.contractDepthSELLList
  );
  const contractDepthBuyListSmall = useSelector(
    (state) => state.sessions.contractDepthBUYListSmall
  );
  const contractDepthSellListSmall = useSelector(
    (state) => state.sessions.contractDepthSELLListSmall
  );
  const activeOffers = useSelector((state) => state.offers.activeOffers);
  const { systemParticipantMatches } = useSelector(
    (state) => state.offers.systemParticipantMatches
  );
  const [modalEditBuyOffer, setModalEditBuyOffer] = useState(false);
  const [modalEditSellOffer, setModalEditSellOffer] = useState(false);
  const [editedOffer, setEditedOffer] = useState();
  const [editedOfferClone, setEditedOfferClone] = useState();
  const [editBuyOfferConfirmation, setEditBuyOfferConfirmation] =
    useState(false);
  const [contractDepthModal, setContractDepthModal] = useState(false);
  const [editBuyOfferLoading, setEditBuyOfferLoading] = useState(false);
  const [deletedOffer, setDeletedOffer] = useState();
  const [deletedBuyOffer, setDeletedBuyOffer] = useState(false);
  const [deletedSellOffer, setDeletedSellOffer] = useState(false);
  const [deletedOfferLoading, setDeletedOfferLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("OFFERS");
  const [objectionOffer, setObjectionOffer] = useState();

  const [objectionDescription, setObjectionDescription] = useState("");
  const [objectionRequestLoading, setObjectionRequestLoading] = useState(false);
  const [objectionConfirmationModal, setObjectionConfirmationModal] =
    useState(false);
  const [selectedContractStatus, setSelectedContractStatus] =
    useState("ACTIVE");
  const [organizationBuyLimit, setOrganizationBuyLimit] = useState(0);
  const [objectionMinute, setObjectionMinute] = useState(20);

  const offerStatusHandling = {
    CANCELLED: {
      color: "important",
      text: t("pages.default.offerOperations.status.cancelled"),
      showEdit: false,
      showDelete: false,
    },
    OPEN: {
      color: "success",
      text: t("pages.default.offerOperations.status.open"),
      showEdit: true,
      showDelete: true,
    },
    SOLD: {
      color: "primary",
      text: t("pages.default.offerOperations.status.sold"),
      showEdit: false,
      showDelete: false,
    },
    DELETED: {
      color: "default",
      text: t("pages.default.offerOperations.status.deleted"),
      showEdit: false,
      showDelete: false,
    },
    CLOSED: {
      color: "new",
      text: t("pages.default.offerOperations.status.closed"),
      showEdit: false,
      showDelete: false,
    },
    DRAFT: {
      color: "attention",
      text: t("pages.default.offerOperations.status.draft"),
      showEdit: true,
      showDelete: true,
    },
  };
  const contractsColumns = [
    {
      key: "contract",
      name: t("pages.default.offerOperations.table.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      key: "bestBuyAmount",
      name: t("pages.default.offerOperations.table.bestBuyAmount"),
      selector: "bestBuyAmount",
      sortable: true,
    },
    {
      key: "bestSpread",
      name: t("pages.default.offerOperations.table.bestSpread"),
      selector: "bestSpread",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.bestSpread, digit: 2 });
      },
    },
    {
      key: "bestSellAmount",
      name: t("pages.default.offerOperations.table.bestSellAmount"),
      selector: "bestSellAmount",
      sortable: true,
    },
    {
      key: "maxMatchPrice",
      name: t("pages.default.offerOperations.table.maxMatchPrice"),
      selector: "maxMatchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.maxMatchPrice, digit: 2 });
      },
    },
    {
      key: "minMatchPrice",
      name: t("pages.default.offerOperations.table.minMatchPrice"),
      selector: "minMatchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.minMatchPrice, digit: 2 });
      },
    },
    {
      key: "lastMatchAmount",
      name: t("pages.default.offerOperations.table.lastMatchAmount"),
      selector: "lastMatchAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.lastMatchAmount);
      },
    },
    {
      key: "lastMatchPrice",
      name: t("pages.default.offerOperations.table.lastMatchPrice"),
      selector: "lastMatchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.lastMatchPrice, digit: 2 });
      },
    },
    {
      key: "tradingVolume",
      name: t("pages.default.offerOperations.table.tradingVolume"),
      selector: "tradingVolume",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.tradingVolume);
      },
    },
    {
      key: "weightedAverage",
      name: t("pages.default.offerOperations.table.weightedAverage"),
      selector: "weightedAverage",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.weightedAverage, digit: 2 });
      },
    },
    {
      key: "status",
      name: t("pages.default.offerOperations.table.status"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return row.status === "ACTIVE" ? (
          <Pill
            type="success"
            label={t("pages.default.offerOperations.active")}
            emphasis
          />
        ) : (
          <Pill
            type="important"
            label={t("pages.default.offerOperations.passive")}
            emphasis
          />
        );
      },
    },
    {
      key: "contractEndTime",
      name: t("pages.default.offerOperations.table.contractEndTime"),
      selector: "contractEndTime",
      sortable: true,
    },
  ];
  const buyListColumns = [
    {
      name: t("pages.default.offerOperations.table.amount"),
      selector: "remainingAmount",
      sortable: false,
      cell: (row) => {
        return (
          <OfferHandler
            className="km__u--text-green-300"
            organizationId={selectedOrganization.organizationId}
            offerOrganizationId={row.organizationId}
            value={convertAmountToFrontend(row.remainingAmount)}
          ></OfferHandler>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.priceCurrency"),
      selector: "price",
      sortable: false,
      cell: (row) => {
        return (
          <OfferHandler
            className="km__u--text-green-300"
            organizationId={selectedOrganization.organizationId}
            offerOrganizationId={row.organizationId}
            value={`${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`}
          ></OfferHandler>
        );
      },
    },
  ];
  const sellListColumns = [
    {
      name: t("pages.default.offerOperations.table.amount"),
      selector: "remainingAmount",
      sortable: false,
      cell: (row) => {
        return (
          <OfferHandler
            className="km__u--text-red-300"
            organizationId={selectedOrganization.organizationId}
            offerOrganizationId={row.organizationId}
            value={convertAmountToFrontend(row.remainingAmount)}
          ></OfferHandler>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.priceCurrency"),
      selector: "price",
      sortable: false,
      cell: (row) => {
        return (
          <OfferHandler
            className="km__u--text-red-300"
            organizationId={selectedOrganization.organizationId}
            offerOrganizationId={row.organizationId}
            value={`${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`}
          ></OfferHandler>
        );
      },
    },
  ];
  const offersColumns = [
    {
      name: t("pages.default.offerOperations.table.orderId"),
      selector: "shownId",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.organizationName"),
      selector: "organizationName",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.date"),
      selector: "modifiedAt",
      sortable: true,
      cell: (row) => {
        return moment(row.modifiedAt).format("DD.MM.YYYY HH:mm:ss");
      },
    },
    {
      name: t("pages.default.offerOperations.table.type"),
      selector: "type",
      sortable: true,
      cell: (row) => {
        return "standart";
      },
    },
    {
      name: t("pages.default.offerOperations.table.price"),
      selector: "price",
      sortable: true,
      cell: (row) => {
        return `${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`;
      },
    },
    {
      name: t("pages.default.offerOperations.table.amount"),
      selector: "amount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.amount);
      },
    },
    {
      name: t("pages.default.offerOperations.table.remainingAmount"),
      selector: "remainingAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.remainingAmount);
      },
    },
    {
      name: t("pages.default.offerOperations.table.orderType"),
      selector: "orderType",
      sortable: true,
      cell: (row) => {
        return (
          <span
            className={
              row.orderType === "BUY"
                ? "km__u--text-green-300"
                : "km__u--text-red-300"
            }
          >
            {row.orderType === "BUY"
              ? t("pages.default.offerOperations.buy")
              : t("pages.default.offerOperations.sell")}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.status"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return (
          <Pill
            type={offerStatusHandling[row.status].color}
            label={offerStatusHandling[row.status].text}
            emphasis
          />
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.action"),
      selector: "action",
      sortable: true,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            {offerStatusHandling[row.status].showEdit && (
              <Button
                title={t("ui.default.edit")}
                onClick={() => clickOfferEdit(row)}
                suffixIcon="edit"
                type="secondary"
              />
            )}
            {offerStatusHandling[row.status].showDelete && (
              <Button
                title={t("ui.default.delete")}
                suffixIcon="x"
                type="destructive"
                onClick={() => deleteOffer(row)}
              />
            )}
          </div>
        );
      },
    },
  ];
  const matchesColumns = [
    {
      name: t("pages.default.offerOperations.table.matchDate"),
      selector: "matchDate",
      sortable: true,
      cell: (row) => {
        return moment(row.matchDate).format("DD.MM.YYYY HH:mm:ss");
      },
    },
    {
      name: t("pages.default.offerOperations.table.orderId"),
      selector: "orderId",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.orderAmount"),
      selector: "quantity",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.orderPrice"),
      selector: "price",
      sortable: true,
      cell: (row) => {
        return `${convertNumberToFrontend({ num: row.price, digit: 2 })} ₺`;
      },
    },
    {
      name: t("pages.default.offerOperations.table.matchAmount"),
      selector: "matchQuantity",
      sortable: true,
    },
    {
      name: t("pages.default.offerOperations.table.matchPrice"),
      selector: "matchPrice",
      sortable: true,
      cell: (row) => {
        return `${convertNumberToFrontend({
          num: row.matchPrice,
          digit: 2,
        })} ₺`;
      },
    },
    {
      name: t("pages.default.offerOperations.table.orderType"),
      selector: "orderType",
      sortable: true,
      cell: (row) => {
        return (
          <span
            className={
              row.orderType === "BUY"
                ? "km__u--text-green-300"
                : "km__u--text-red-300"
            }
          >
            {row.orderType === "BUY"
              ? t("pages.default.offerOperations.buy")
              : t("pages.default.offerOperations.sell")}
          </span>
        );
      },
    },
    {
      name: t("pages.default.offerOperations.table.action"),
      selector: "id",
      sortable: false,
      cell: (row) => {
        return (
          <Button
            title={t("pages.default.objections.object")}
            label={t("pages.default.objections.object")}
            type="destructive"
            onClick={() => {
              clickObjection(row);
            }}
            disabled={
              !row.objectionAble
              // !(
              //   -moment(row.matchDate).diff(serverTime, "seconds") <=
              //   objectionMinute * 60
              // ) ||
              // (row?.details?.buyOrder?.organizationId ===
              // selectedOrganization?.organizationId
              //   ? row?.details?.buyerObjected
              //   : row?.details?.sellerObjected) ||
              // row?.status?.value === "CANCELLED"
            }
          />
        );
      },
    },
    {
      name: t("pages.default.marketResults.table.status"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return row.status.value === "VALID" ? (
          <Pill type="success" label={row.status.text} emphasis />
        ) : (
          <Pill type="important" label={row.status.text} emphasis />
        );
      },
    },
  ];

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps

    setInterval(function () {
      API_GET("system-date-time/full").then((res) => {
        const time = res.data;
        setIntervalState(time);
      });
    }, 2000);

    return () => {
      clearInterval(timer1);
    };
  }, []);

  useEffect(() => {
    getCurrentSession();
    getObjectionMinute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get contracts, offer depths, offers, matches and objectionMinute for every 5 sec
  useEffect(() => {
    const interval = setInterval(() => {
      getCurrentSession();
      getObjectionMinute();
      if (selectedContract) {
        API_GET(`system-parameter/contract/${selectedContract.id}`).then(
          (res) => {
            setSelectedContractStatus(res.data.status);
          }
        );
        dispatch(
          getContractDepthRequested({
            contractId: selectedContract.id,
            systemParticipant: true,
          })
        );
        dispatch(
          getActiveOffersRequested({
            contractId: selectedContract.id,
            organizationId: selectedOrganization.organizationId,
          })
        );
        dispatch(
          getSystemParticipantMatchesRequested({
            contractId: selectedContract.id,
            organizationId: selectedOrganization.organizationId,
            noPage: true,
          })
        );
      }
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContract]);

  // get current balance for every 5 sec
  useEffect(() => {
    const interval = setInterval(() => {
      if (selectedOrganization) {
        API_GET(
          `exchange-order/guarantee/currentBalance/${selectedOrganization.organizationId}`
        ).then((res) => {
          setOrganizationBuyLimit(res.data);
        });
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedOrganization]);

  const seanceIsActive = useMemo(() => {
    if (!Array.isArray(currentContracts) || currentContracts.length < 0) {
      return false;
    }

    const now = moment(intervalState);
    const end = moment(currentContracts?.[0]?.contractEndDate);
    const duration = moment.duration(now.diff(end));
    const days = duration.asMilliseconds();
    if (days > 0) {
      return false;
    }

    const findedActiveRow = currentContracts.find(
      (item) => item?.status === "ACTIVE"
    );

    return findedActiveRow ? true : false;
  }, [currentContracts, intervalState]);

  const getTableResultJsx = () => {
    if (loading && currentContracts.length === 0) {
      return <Loading />;
    }

    const rule1 = currentContracts.length === 0;
    let rule2 = false;

    if (currentContracts.length > 0) {
      const now = moment(intervalState);
      const end = moment(currentContracts?.[0]?.contractEndDate);
      const duration = moment.duration(now.diff(end));
      const days = duration.asMilliseconds();
      if (days > 0) {
        rule2 = true;
      }
    }

    if (!loading && (rule1 || rule2)) {
      return (
        <EmptyState
          icon="file-text"
          text={t("pages.default.offerOperations.contractNotFound")}
        />
      );
    }

    return null;
  };

  const getObjectionMinute = async () => {
    let res = await API_GET("system-parameter/parameter");
    let OBJECTION_MINUTE = res.data.find((item) => {
      return item.parameterName === "objection_period";
    });
    setObjectionMinute(OBJECTION_MINUTE.parameterValue);
  };

  const getCurrentSession = () => {
    API_GET(
      `exchange-order/guarantee/currentBalance/${selectedOrganization.organizationId}`
    ).then((res) => {
      setOrganizationBuyLimit(res.data);
    });
    dispatch(getCurrentSessionsRequested());
  };

  const contractSelection = (row) => {
    dispatch(contractSelect(row));
    setSelectedContractStatus(row.status);
    dispatch(
      getContractDepthRequested({ contractId: row.id, systemParticipant: true })
    );
    dispatch(
      getActiveOffersRequested({
        contractId: row.id,
        organizationId: selectedOrganization.organizationId,
      })
    );
    dispatch(
      getSystemParticipantMatchesRequested({
        contractId: row.id,
        organizationId: selectedOrganization.organizationId,
        noPage: true,
      })
    );
  };

  const contractRowSelected = (row) => {
    if (selectedContract) return row.id === selectedContract.id;
    else return false;
  };

  const clickOfferEdit = (row) => {
    setEditedOffer(row);
    setEditedOfferClone(row);
    if (row.orderType === "BUY") {
      setModalEditBuyOffer(true);
    } else {
      setModalEditSellOffer(true);
    }
  };

  const deleteOffer = (row) => {
    setDeletedOffer(row);
    if (row.orderType === "BUY") {
      setDeletedBuyOffer(true);
    } else {
      setDeletedSellOffer(true);
    }
  };

  const deleteOfferRequest = async () => {
    try {
      setDeletedOfferLoading(true);
      let resOffers = await API_GET(`exchange-order/search`, {
        orderGroupId: deletedOffer.orderGroupId,
      });
      let offers = resOffers.data.items;
      for (let offer of offers) {
        await API_DELETE(`exchange-order/${offer.id}`);
      }
      setNotification(
        "success",
        t("pages.default.offerOperations.success.remove")
      );
      dispatch(
        getContractDepthRequested({
          contractId: selectedContract.id,
          systemParticipant: true,
        })
      );
      dispatch(
        getActiveOffersRequested({
          contractId: selectedContract.id,
          organizationId: selectedOrganization.organizationId,
        })
      );
      setDeletedOfferLoading(false);
      setDeletedBuyOffer(false);
      setDeletedSellOffer(false);
    } catch (err) {
      setNotification("error", err.response.data.message);
      setDeletedOfferLoading(false);
    }
  };
  const editOfferChange = (e) => {
    setEditedOffer({
      ...editedOffer,
      [e.target.name]: e.target.value,
    });
  };
  const validateEditBuyOfferRequest = () => {
    if (!editedOffer.remainingAmount) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.amount")
      );
      return false;
    }
    if (!editedOffer.price) {
      setNotification("error", t("pages.default.offerOperations.errors.price"));
      return false;
    }
    return true;
  };
  const editBuyOfferRequest = async () => {
    if (!validateEditBuyOfferRequest()) {
      return;
    }
    setEditBuyOfferLoading(true);
    try {
      let updatedOffer = {
        deleteRequests: [],
        updateRequests: [],
        createRequests: [],
        passiveRequests: [],
        activeRequests: [],
      };
      // status check
      if (editedOfferClone.status !== editedOffer.status) {
        if (editedOffer.status === "OPEN") {
          updatedOffer.activeRequests.push({ orderId: editedOffer.id });
        } else {
          updatedOffer.passiveRequests.push({ orderId: editedOffer.id });
        }
      }
      if (
        editedOfferClone.remainingAmount !== editedOffer.remainingAmount ||
        editedOfferClone.price !== editedOffer.price ||
        editedOfferClone.status !== editedOffer.status
      ) {
        updatedOffer.updateRequests = [
          {
            price: editedOffer.price,
            amount:
              editedOffer.amount +
              parseInt(editedOffer.remainingAmount) -
              parseInt(editedOfferClone.remainingAmount),

            prevAmount: editedOfferClone.remainingAmount,
            orderId: editedOffer.id,
            status: editedOffer.status,
          },
        ];
      }
      await API_POST("exchange-order/multi", updatedOffer);
      dispatch(
        getActiveOffersRequested({
          contractId: selectedContract.id,
          organizationId: selectedOrganization.organizationId,
        })
      );
      setNotification(
        "success",
        t("pages.default.offerOperations.success.buyOfferUpdate")
      );
      setModalEditBuyOffer(false);
      setEditBuyOfferLoading(false);
      setEditBuyOfferConfirmation(false);
      setEditedOffer();
      setEditedOfferClone();
    } catch (err) {
      setEditBuyOfferLoading(false);
      setNotification("error", err.response.data.message);
    }
  };

  const clickObjection = (row) => {
    if (-moment(row.matchDate).diff(serverTime, "minutes") <= objectionMinute) {
      setObjectionOffer(row);
      return;
    }
    setNotification(
      "error",
      t("pages.default.offerOperations.errors.objectionTime")
    );
  };
  const objectionDescriptionChange = (e) => {
    setObjectionDescription(e.target.value);
  };
  const validateObjectionRequest = () => {
    if (!objectionDescription) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.objectionEmpty")
      );
      return false;
    }
    if (objectionDescription.length < 10) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.objectionCharacterLimit")
      );
      return false;
    }
    return true;
  };
  const objectionConfirmationToggle = () => {
    if (!validateObjectionRequest()) {
      return false;
    }
    setObjectionConfirmationModal(true);
  };
  const objectionRequest = async () => {
    if (!validateObjectionRequest()) {
      return false;
    }
    try {
      setObjectionRequestLoading(true);
      await API_POST("objections", {
        bundleId: objectionOffer.id,
        organizationId: selectedOrganization.organizationId,
        note: objectionDescription,
      });
      setNotification(
        "success",
        t("pages.default.offerOperations.success.objection")
      );
      setObjectionOffer();
      setObjectionDescription("");
      setObjectionRequestLoading(false);
      setObjectionConfirmationModal(false);
    } catch (err) {
      setNotification("error", err.response.data.message);
      setObjectionRequestLoading(false);
    }
  };

  return (
    <>
      <h5 className="km__u--text-has-emphasis km__p--offer-operations-header-container">
        {t("pages.default.offerOperations.title")}
        <div className="km__p--offer-operations-switch-container">
          <ToggleSwitch
            label={t("pages.default.offerOperations.homepage")}
            checked={true}
            onClick={() => history.push("/")}
            readOnly
            id="home-toggle"
          />
        </div>
      </h5>

      <div className="km__p--card">
        {seanceIsActive && (
          <div className="km__p--offer-operations-contracts">
            <p className="km__u--text_title">
              {t("pages.default.offerOperations.contracts")}
            </p>
            {/* Kontratlar */}
            <DataTableDraggable
              cookieName="columns-sp"
              selectableRow
              rowKey="id"
              rowSelection={(row) => contractSelection(row)}
              isRowSelected={(row) => contractRowSelected(row)}
              columns={contractsColumns}
              data={currentContracts}
            />
          </div>
        )}
        {getTableResultJsx()}
      </div>
      {seanceIsActive && selectedContract && (
        <>
          <div className="km__p--offer-operations-contract-depth-container">
            {/* Açık Emirler */}
            <div className="km__p--offer-operations-contract-depth w-50">
              <p className="km__u--text_title">
                <span
                  className="km__p--offer-operations-contract-depth-expand"
                  onClick={() => setContractDepthModal(true)}
                >
                  <Icon name="maximize" size="16" />
                </span>{" "}
                {t("pages.default.offerOperations.contractDepth")} -{" "}
                {selectedContract.contractName}
              </p>
              <div>
                <div className="km__p--offer-operations-buy-list">
                  <div className="km__p--offer-operations-buy-list-header">
                    <span className="km__u--text_title km__u--text-green-300">
                      {t("pages.default.offerOperations.buy")}
                    </span>
                  </div>
                  <DataTableBasic
                    rowKey="id"
                    columns={buyListColumns}
                    data={contractDepthBuyListSmall}
                  />
                </div>
                <div className="km__p--offer-operations-sell-list">
                  <div className="km__p--offer-operations-sell-list-header">
                    <span className="km__u--text_title km__u--text-red-300">
                      {t("pages.default.offerOperations.sell")}
                    </span>
                  </div>
                  <DataTableBasic
                    rowKey="id"
                    columns={sellListColumns}
                    data={contractDepthSellListSmall}
                  />
                </div>
              </div>
            </div>
            {/* Alış Satış Emri Verme */}
            {selectedContractStatus === "ACTIVE" && (
              <div className="km__p--offer-operations-offer w-50">
                {selectedOrganization ? (
                  <OfferTab
                    t={t}
                    selectedOrganization={selectedOrganization}
                    isAdmin={false}
                    organizationBuyLimit={organizationBuyLimit}
                  />
                ) : null}
              </div>
            )}
          </div>
          {selectedContractStatus === "ACTIVE" && (
            <div className="km__p--offer-operations-offers">
              <div className="km__p--offer-operations-offers-header">
                <p
                  className={`km__u--text_title ${
                    activeTab === "OFFERS" ? "km__p--offers-active-tab" : ""
                  }`}
                  onClick={() => setActiveTab("OFFERS")}
                >
                  {t("pages.default.offerOperations.myOffers")}
                </p>
                <p
                  className={`km__u--text_title ${
                    activeTab === "MATCHES" ? "km__p--offers-active-tab" : ""
                  }`}
                  onClick={() => setActiveTab("MATCHES")}
                >
                  {t("pages.default.offerOperations.myMatches")}
                </p>
              </div>
              <div className="km__p--card">
                {activeTab === "OFFERS" && (
                  <DataTable
                    rowKey="id"
                    defaultSortedField="id"
                    pagination
                    paginationPerPage={10}
                    columns={offersColumns}
                    data={activeOffers}
                  />
                )}
                {activeTab === "MATCHES" && (
                  <DataTable
                    rowKey="id"
                    defaultSortedField="matchDate"
                    pagination
                    paginationPerPage={10}
                    columns={matchesColumns}
                    data={systemParticipantMatches}
                  />
                )}
              </div>
            </div>
          )}
        </>
      )}
      {/* Kontrat Derinliği Modal */}
      {selectedContract && (
        <Modal
          isOpen={contractDepthModal}
          toggle={() => setContractDepthModal(false)}
        >
          <div className="km__p--offer-operations-contract-depth-header">
            <p className="km__u--text_title">
              {t("pages.default.offerOperations.contractDepth")} -{" "}
              {selectedContract.contractName}
            </p>
            <span onClick={() => setContractDepthModal(false)}>
              <Icon name="x" size="16" />
            </span>
          </div>
          <div className="km__p--offer-operations-contract-depth-row">
            <div className="km__p--offer-operations-contract-depth-column">
              <span className="km__u--text_title km__u--text-green-300">
                {t("pages.default.offerOperations.buy")}
              </span>
              <DataTable
                rowKey="id"
                columns={buyListColumns}
                data={contractDepthBuyList}
                pagination
                paginationPerPage={10}
              />
            </div>
            <div className="km__p--offer-operations-contract-depth-column">
              <span className="km__u--text_title km__u--text-red-300">
                {t("pages.default.offerOperations.sell")}
              </span>
              <DataTable
                rowKey="id"
                columns={sellListColumns}
                data={contractDepthSellList}
                pagination
                paginationPerPage={10}
              />
            </div>
          </div>
        </Modal>
      )}
      {/* Alış teklifi güncelleme */}
      {editedOffer && selectedContractStatus === "ACTIVE" && (
        <Modal isOpen={modalEditBuyOffer} toggle={setModalEditBuyOffer}>
          <div className="km__p-modal-edit-buy-offer-body">
            <Input
              label={t("pages.default.offerOperations.orderId")}
              type="text"
              value={editedOffer.shownId}
              disabled
            />
            <Input
              label={t("pages.default.offerOperations.orderType")}
              type="text"
              value={t(
                `ui.default.offerTab.${editedOffer.orderType.toLowerCase()}`
              )}
              disabled
            />
            <Input
              label={t("pages.default.offerOperations.standartOrderType")}
              type="text"
              value={"Standart"}
              disabled
            />
            <Select
              label={t("pages.default.offerOperations.orderStatus")}
              value={editedOffer.status}
              name="status"
              onChange={editOfferChange}
              options={[
                {
                  name: t("pages.default.offerOperations.active"),
                  value: "OPEN",
                },
                {
                  name: t("pages.default.offerOperations.passive"),
                  value: "DRAFT",
                },
              ]}
            />
            <Input
              label={t("pages.default.offerOperations.amount")}
              type="number"
              name="remainingAmount"
              min={1}
              onChange={editOfferChange}
              value={editedOffer.remainingAmount}
            />
            <PriceInput
              label={t("pages.default.offerOperations.price")}
              type="number"
              name="price"
              min={selectedContract.minPrice}
              max={selectedContract.maxPrice}
              acceptDecimal
              onChange={editOfferChange}
              value={editedOffer.price}
            />
            <Input
              label={t("pages.default.offerOperations.totalPrice")}
              type="text"
              disabled
              value={`${convertNumberToFrontend({
                num: editedOffer.price * editedOffer.remainingAmount,
                digit: 2,
              })} ₺`}
            />
            <LabelValue
              label={t("pages.default.offerOperations.orderLimit")}
              value={convertNumberToFrontend({
                num: organizationBuyLimit ? organizationBuyLimit : 0,
                digit: 2,
              })}
            />
          </div>
          <div className="km__p-modal-edit-buy-offer-footer">
            <Button
              type="secondary"
              onClick={() => setModalEditBuyOffer(!modalEditBuyOffer)}
              label={t("ui.default.discard")}
            />
            <Button
              type="primary"
              onClick={() => setEditBuyOfferConfirmation(true)}
              label={t("pages.default.offerOperations.updateOrder")}
            />
          </div>
        </Modal>
      )}
      {/* Satış teklifi güncelleme */}
      {editedOffer &&
        selectedContractStatus === "ACTIVE" &&
        modalEditSellOffer && (
          <ModalEditSellOffer
            t={t}
            editedOffer={editedOffer}
            selectedContract={selectedContract}
            isOpen={modalEditSellOffer}
            toggle={setModalEditSellOffer}
            row={editedOffer}
          />
        )}
      {objectionOffer && selectedContractStatus === "ACTIVE" && (
        <Modal
          isOpen={objectionOffer ? true : false}
          toggle={() => setObjectionOffer()}
        >
          <div className="km__p--objection-post-modal-header">
            <p className="km__u--text-title">
              {t("pages.default.objections.doObject")}
            </p>
          </div>
          <div className="km__p--objection-post-modal-detail">
            <div className="km__p--objection-post-modal-detail-column">
              <TitleValue
                title={t("pages.default.objections.modal.organization")}
                value={objectionOffer.organizationName}
                size="lg"
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderId")}
                value={objectionOffer.orderId}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderDate")}
                value={moment(objectionOffer?.offerDate).format(
                  "DD.MM.YYYY HH:mm:ss"
                )}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.matchDate")}
                value={moment(objectionOffer.matchDate).format(
                  "DD.MM.YYYY HH:mm:ss"
                )}
              />
            </div>
            <div className="km__p--objection-post-modal-detail-column">
              <TitleValue
                title={t("pages.default.objections.modal.userName")}
                value={objectionOffer?.userName || "-"}
                size="lg"
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderPrice")}
                value={`${convertNumberToFrontend({
                  num: objectionOffer.price,
                  digit: 2,
                })} ₺`}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderAmount")}
                value={convertAmountToFrontend(objectionOffer.quantity)}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.matchPrice")}
                value={`${convertNumberToFrontend({
                  num: objectionOffer.matchPrice,
                  digit: 2,
                })} ₺`}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.matchAmount")}
                value={convertAmountToFrontend(objectionOffer.matchQuantity)}
              />
            </div>
          </div>
          <div className="km__p--objection-post-modal-input">
            <Textarea
              label={t("pages.default.objections.modal.note")}
              defaultValue={objectionDescription}
              onChange={objectionDescriptionChange}
              value={objectionDescription}
            />
          </div>
          <div className="km__p--objection-post-modal-footer">
            <Button
              label={t("ui.default.discard")}
              type="secondary"
              onClick={() => setObjectionOffer()}
            />
            <Button
              label={t("pages.default.objections.doObject")}
              type="primary"
              onClick={() => objectionConfirmationToggle()}
            />
          </div>
        </Modal>
      )}
      {/* Satış teklifi silme */}
      {deletedSellOffer && (
        <ModalConfirmation
          toggle={() => setDeletedSellOffer()}
          isOpen={deletedSellOffer}
          header={t(
            "pages.default.offerOperations.confirmations.deleteSellOffer.title"
          )}
          body={t(
            "pages.default.offerOperations.confirmations.deleteSellOffer.description"
          )}
          approve={deleteOfferRequest}
          loading={deletedOfferLoading}
        />
      )}
      {/* Alış teklifi silme */}
      {deletedBuyOffer && (
        <ModalConfirmation
          toggle={() => setDeletedBuyOffer()}
          isOpen={deletedBuyOffer}
          header={t(
            "pages.default.offerOperations.confirmations.deleteBuyOffer.title"
          )}
          body={t(
            "pages.default.offerOperations.confirmations.deleteBuyOffer.description"
          )}
          approve={deleteOfferRequest}
          loading={deletedOfferLoading}
        />
      )}
      <ModalConfirmation
        toggle={() => setEditBuyOfferConfirmation(false)}
        isOpen={editBuyOfferConfirmation}
        header={t(
          "pages.default.offerOperations.confirmations.updateBuyOffer.title"
        )}
        body={t(
          "pages.default.offerOperations.confirmations.updateBuyOffer.description"
        )}
        approve={editBuyOfferRequest}
        loading={editBuyOfferLoading}
      />
      <ModalConfirmation
        toggle={() => setObjectionConfirmationModal(false)}
        isOpen={objectionConfirmationModal}
        header={t("pages.default.offerOperations.confirmations.object.title")}
        body={t(
          "pages.default.offerOperations.confirmations.object.description"
        )}
        approve={objectionRequest}
        loading={objectionRequestLoading}
      />
    </>
  );
}
